import { render, staticRenderFns } from "./DocumentSelector.vue?vue&type=template&id=21406468"
import script from "./DocumentSelector.vue?vue&type=script&lang=js"
export * from "./DocumentSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports